import React from "react";
import Navbar from "../components/Navbar";
import "./OmnichannelMessagingPage.css";

const VENDOR_REGISTRATION_URL = "https://lusuku.shop/vendorRegistration";
const VENDOR_INBOX_URL = "https://lusuku-prod-server.herokuapp.com/admin/omnichannel-inbox";
const CUSTOMER_WHATSAPP_URL =
  "https://wa.me/256700771301?text=Hi%20Lusuku%2C%20I%20need%20help%20with%20an%20order.";

const OmnichannelMessagingPage = () => {
  return (
    <>
      <Navbar />
      <main className="omni-page">
        <div className="omni-bg-mark omni-bg-mark--one" />
        <div className="omni-bg-mark omni-bg-mark--two" />
        <section className="omni-hero">
          <div className="omni-hero__content">
            <div className="omni-channel-strip" aria-label="Supported channel flow">
              <span>WhatsApp Business</span>
              <span>Shared team inbox</span>
              <span>Orders & support</span>
            </div>
            <p className="omni-eyebrow">WhatsApp Business, connected to Lusuku</p>
            <h1>Turn WhatsApp conversations into orders and better support.</h1>
            <p>
              Keep the WhatsApp Business number your customers already know. Your team can respond
              from one shared inbox, assign conversations, and create Lusuku orders without switching tools.
            </p>
            <div className="omni-actions">
              <a href={CUSTOMER_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                Customer WhatsApp chat
              </a>
              <a href={VENDOR_INBOX_URL}>
                Vendor staff login
              </a>
              <a href={VENDOR_REGISTRATION_URL}>
                Start vendor registration
              </a>
            </div>
            <div className="omni-audience-flow" aria-label="Customer and vendor chat flow">
              <div>
                <strong>Customer side</strong>
                <span>Customers start a familiar WhatsApp conversation from your shop, receipt, or support link.</span>
              </div>
              <div>
                <strong>Vendor side</strong>
                <span>Your team replies together, keeps ownership clear, and turns requests into orders.</span>
              </div>
            </div>
            <div className="omni-stats" aria-label="Messaging capabilities">
              <div>
                <strong>1</strong>
                <span>Shared inbox</span>
              </div>
              <div>
                <strong>4</strong>
                <span>Connected tools</span>
              </div>
              <div>
                <strong>24h</strong>
                <span>WhatsApp reply window</span>
              </div>
            </div>
          </div>
          <div className="omni-hero__panel" aria-label="Inbox preview">
            <div className="omni-panel-top">
              <span className="omni-dot" />
              <span>Live conversation</span>
              <strong>Assigned</strong>
            </div>
            <div className="omni-chat omni-chat--customer">
              <span>WhatsApp customer</span>
              Do you have chicken biryani today?
            </div>
            <div className="omni-chat omni-chat--agent">
              <span>Lusuku agent</span>
              Yes. I can turn this chat into an order now.
            </div>
            <div className="omni-order-card">
              <div>
                <small>Order draft</small>
                <strong>Chicken biryani x2</strong>
              </div>
              <button type="button">Convert</button>
            </div>
            <div className="omni-workflow" aria-label="Conversation workflow">
              <span><b>01</b> Customer sends a message</span>
              <span><b>02</b> Your team responds</span>
              <span><b>03</b> Request becomes an order</span>
            </div>
          </div>
        </section>

        <section className="omni-grid">
          <article>
            <h2>Familiar for customers</h2>
            <p>
              Customers keep using WhatsApp and the business number they already trust—no new app,
              account, or unfamiliar support process required.
            </p>
          </article>
          <article>
            <h2>Simple for your team</h2>
            <p>
              New conversations arrive in a shared Lusuku inbox where staff can reply, assign an owner,
              and keep every customer request moving.
            </p>
          </article>
          <article>
            <h2>Connected to daily work</h2>
            <p>
              Turn a conversation into an order or support request, then follow its progress alongside
              the rest of your Lusuku operations.
            </p>
          </article>
        </section>

        <section className="omni-checklist">
          <div>
            <h2>Before connecting WhatsApp</h2>
            <p>
              You’ll need access to your WhatsApp Business number and permission to connect it to Lusuku.
              Our team will guide you through setup and help you confirm everything is ready before launch.
            </p>
          </div>
          <ul>
            <li>Keep the business number your customers already recognise.</li>
            <li>Give approved staff access to one shared inbox.</li>
            <li>Assign conversations and create orders or support requests.</li>
            <li>See response activity and conversation progress in one place.</li>
          </ul>
        </section>
      </main>
    </>
  );
};

export default OmnichannelMessagingPage;
